import { isEmailValid } from '@organization/utils'
import { Avatar, Button, Flex, Typography } from 'antd'
import { UserSearch } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  keyword?: string
  onInvite?: () => void
  isLoading?: boolean
}

export const OptionNotFound = ({ keyword, onInvite, isLoading }: Props) => {
  const { t } = useTranslation()

  const title = keyword ? `${t('common.for_the')} “${keyword}”` : ''
  const isValid = isEmailValid(keyword)

  return (
    <Flex vertical gap={8}>
      <Flex align="start" gap={8}>
        <div>
          <Avatar size={32} icon={<UserSearch size={16} />} />
        </div>
        <div>
          <Typography.Text strong>{`${t(
            'error.no_results'
          )} ${title}`}</Typography.Text>
          {/* <Typography.Paragraph>
            {t('users.would_like_new_user')}
          </Typography.Paragraph> */}
        </div>
      </Flex>

      {/* <Button
        type="primary"
        loading={isLoading}
        onClick={onInvite}
        disabled={!isValid}
      >
        {t('users.send_invite')}
      </Button> */}
    </Flex>
  )
}
